import $ from 'jquery'

const $doc = $(document)

function menuDropdownA11y() {
  /*
  Adapted from: An accessible menu for WordPress
  https://github.com/argenteum/accessible-nav-wp
  Licensed GPL v.2 (http://www.gnu.org/licenses/gpl-2.0.html)
  This work derived from:
  https://github.com/WordPress/twentysixteen (GPL v.2)
  https://github.com/wpaccessibility/a11ythemepatterns/tree/master/menu-keyboard-arrow-nav (GPL v.2)
  */

  let menuContainer = $('.js-header');
  let siteHeaderMenu = menuContainer.find('.js-header-wrapper');

  // If you are using WordPress, and do not need to localise your script, or if you are not using WordPress, then uncomment the next line

  let screenReaderText = {"expand":"Expand child menu","collapse":"Collapse child menu"};

  let dropdownToggle = $('<button />', { 'class': 'dropdown-toggle', 'aria-expanded': false })
    .append($('<span />', { 'class': 'u-sr-only', text: screenReaderText.expand }));


  // Adds the dropdown toggle button
  $('.menu-item-has-children > a').after(dropdownToggle);

  // Adds aria attribute
  siteHeaderMenu.find('.menu-item-has-children').attr('aria-haspopup', 'true');

  // Toggles the sub-menu when dropdown toggle button clicked
  siteHeaderMenu.find('.dropdown-toggle').click(function (e) {

    let screenReaderSpan = $(this).find('.u-sr-only');

    e.preventDefault();
    $(this).toggleClass('toggled-on');
    $(this).nextAll('.sub-menu').toggleClass('toggled-on');

    // jscs:disable
    $(this).attr('aria-expanded', $(this).attr('aria-expanded') === 'false'
      ? 'true' : 'false');
    // jscs:enable
    screenReaderSpan.text(screenReaderSpan.text() ===
      screenReaderText.expand ? screenReaderText.collapse :
      screenReaderText.expand);
  });

  // Adds a class to sub-menus for styling
  $('.sub-menu .menu-item-has-children').parent('.sub-menu').addClass('has-sub-menu');


  // Keyboard navigation
  $('.menu-item a, button.dropdown-toggle').on('keydown', function (e) {

    if ([37, 38, 39, 40].indexOf(e.keyCode) == -1) {
      return;
    }

    switch (e.keyCode) {

      case 37: 				// left key
        e.preventDefault();
        e.stopPropagation();

        if ($(this).hasClass('dropdown-toggle')) {
          $(this).prev('a').focus();
        }
        else {

          if ($(this).parent().prev().children('button.dropdown-toggle').length) {
            $(this).parent().prev().children('button.dropdown-toggle').focus();
          }
          else {
            $(this).parent().prev().children('a').focus();
          }
        }

        if ($(this).is('ul ul ul.sub-menu.toggled-on li:first-child a')) {
          $(this).parents('ul.sub-menu.toggled-on li').children('button.dropdown-toggle').focus();
        }

        break;

      case 39: 				// right key
        e.preventDefault();
        e.stopPropagation();

        if ($(this).next('button.dropdown-toggle').length) {
          $(this).next('button.dropdown-toggle').focus();
        }
        else {
          $(this).parent().next().children('a').focus();
        }

        if ($(this).is('ul.sub-menu .dropdown-toggle.toggled-on')) {
          $(this).parent().find('ul.sub-menu li:first-child a').focus();
        }

        break;


      case 40: 				// down key
        e.preventDefault();
        e.stopPropagation();

        if ($(this).next().length) {
          $(this).next().find('li:first-child a').first().focus();
        }
        else {
          $(this).parent().next().children('a').focus();
        }

        if (($(this).is('ul.sub-menu a')) && ($(this).next('button.dropdown-toggle').length)) {
          $(this).parent().next().children('a').focus();
        }

        if (($(this).is('ul.sub-menu .dropdown-toggle')) && ($(this).parent().next().children('.dropdown-toggle').length)) {
          $(this).parent().next().children('.dropdown-toggle').focus();
        }

        break;


      case 38: 				// up key
        e.preventDefault();
        e.stopPropagation();

        if ($(this).parent().prev().length) {
          $(this).parent().prev().children('a').focus();
        }
        else {
          $(this).parents('ul').first().prev('.dropdown-toggle.toggled-on').focus();
        }

        if (($(this).is('ul.sub-menu .dropdown-toggle')) && ($(this).parent().prev().children('.dropdown-toggle').length)) {
          $(this).parent().prev().children('.dropdown-toggle').focus();
        }

        break;

    }
  });
}

function enhancedSelectLabelsA11y() {
  /*
  WP Job Manager enhances the native Category <select> with Select2 (legacy
  builds used Chosen). The enhanced widget exposes role="combobox" but does not
  inherit the native <label>, which accessibility audits flag. Copy the label
  text onto the combobox as an aria-label.
  */
  const labelComboboxes = () => {
    $('select[id]').each(function () {
      const $select = $(this);
      const $label = $(`label[for="${$select.attr('id')}"]`);
      if (!$label.length) return;

      const labelText = $.trim($label.text());
      if (!labelText) return;

      // Select2 inserts its container after the select, but not always as the
      // immediate next sibling (e.g., when wrapped in additional markup).
      let $widget = $select.nextAll('.select2-container, .chosen-container').first();
      if (!$widget.length) {
        $widget = $select.siblings('.select2-container, .chosen-container').first();
      }
      if (!$widget.length) return;

      const $combo = $widget.find('[role="combobox"], .select2-selection, .chosen-single, .chosen-choices');
      if (!$combo.length) return;

      // Set aria-label for broad tool support
      $combo.attr('aria-label', labelText);

      // Also set aria-labelledby for stronger programmatic association
      if (!$label.attr('id')) {
        $label.attr('id', `${$select.attr('id')}-label`);
      }
      $combo.attr('aria-labelledby', $label.attr('id'));
    });
  };

  // Select2/Chosen enhance on DOM ready, so label after ready and on load,
  // and re-apply whenever Select2 re-renders.
  $(labelComboboxes);
  $(window).on('load', labelComboboxes);
  $(document).on('select2:open select2:close select2:select select2:unselect', 'select', labelComboboxes);
}

function fixEmptyAnchors() {
  const patterns = [
    { re: /app\.clarityapp\.com\/sign-in/i, label: 'Sign in to Clarity' },
    { re: /prospectsierra\.org\/prospect-sierra-tour/i, label: 'Prospect Sierra Tour' },
    { re: /parentsquare\.com/i, label: 'Open ParentSquare link' },
  ];

  const anchors = document.querySelectorAll('a[href]');
  if (!anchors.length) return;

  anchors.forEach(function (a) {
    const href = a.getAttribute('href') || '';

    const matched = patterns.find(function (p) { return p.re.test(href); });
    if (!matched) {
      // Still sanitize rel for target=_blank on any anchor
      const t = a.getAttribute('target');
      if (t === '_blank') {
        const rel = a.getAttribute('rel') || '';
        const tokens = rel.split(/\s+/).filter(function (tk) {
          tk = tk.trim();
          return tk && !/^https?:\/\//i.test(tk);
        });
        if (tokens.indexOf('noopener') === -1) tokens.push('noopener');
        if (tokens.indexOf('noreferrer') === -1) tokens.push('noreferrer');
        a.setAttribute('rel', tokens.join(' '));
      }
      return;
    }

    const hasText = (a.textContent || '').trim() !== '';
    const hasAriaLabel = a.hasAttribute('aria-label') && (a.getAttribute('aria-label') || '').trim() !== '';
    const hasLabelledby = a.hasAttribute('aria-labelledby') && (a.getAttribute('aria-labelledby') || '').trim() !== '';
    let hasImgAlt = false;
    a.querySelectorAll('img').forEach(function (img) {
      if ((img.getAttribute('alt') || '').trim() !== '') hasImgAlt = true;
    });

    if (!hasText && !hasAriaLabel && !hasLabelledby && !hasImgAlt) {
      a.setAttribute('aria-label', matched.label);
    }

    const target = a.getAttribute('target');
    if (target === '_blank') {
      const rel = a.getAttribute('rel') || '';
      const tokens = rel.split(/\s+/).filter(function (tk) {
        tk = tk.trim();
        return tk && !/^https?:\/\//i.test(tk);
      });
      if (tokens.indexOf('noopener') === -1) tokens.push('noopener');
      if (tokens.indexOf('noreferrer') === -1) tokens.push('noreferrer');
      a.setAttribute('rel', tokens.join(' '));
    }
  });
}

export default function initA11yFunctions(){
  menuDropdownA11y();
  enhancedSelectLabelsA11y();

  fixEmptyAnchors();
  document.addEventListener('DOMContentLoaded', fixEmptyAnchors);
  window.addEventListener('load', fixEmptyAnchors);

  if (typeof MutationObserver !== 'undefined') {
    const mo = new MutationObserver(function () { fixEmptyAnchors(); });
    mo.observe(document.documentElement, { subtree: true, childList: true });
  }
}
